module.exports = __webpack_public_path__ + "img/privacy.0f0c5d9b.png";